export default __webpack_public_path__ + "static/Shadow_Steak_Saute-0d04df1825ad42e090b4b055d975390a.png";